import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const { REACT_APP_CONTEXT_PATH } = process.env;

// Initial state
const initialState = {
  status: null,
};

// Slice
const checkChatStatusSlice = createSlice({
  name: "checkChatStatus",
  initialState,
  reducers: {
    reqChatStatus(state) {
      return { ...state, loading: true, error: false, loaded: false };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        loaded: true,
      };
    },
    setStatus(state, action) {
      const { status } = action.payload;
      return {
        ...state,
        status,
      };
    },
    initStatus(state) {
      return {
        ...state,
        status : null,
      };
    },
  },
});

export const {
  reqChatStatus,
  fetchDataFailure,
  setStatus,
  initStatus,
} = checkChatStatusSlice.actions;

export default checkChatStatusSlice.reducer;

function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  const { headers = {}, apiUrl, data } = action.payload;

  const apiService = axios.create({
    headers: {
      ...headers,
      user_ip: peerIp
    },
    timeout: 10000,
    baseURL: REACT_APP_CONTEXT_PATH,
  });

  try {
    yield call(apiService.post, apiUrl, data); //chat 상태 확인
    yield put(setStatus({ status: "available" }));
  } catch (error) {
    yield put(fetchDataFailure(error));
    yield put(setStatus({ status: "expired" }));
    return;
  }
}

// API 호출을 감시하는 Saga 함수
export function* checkChatStatusSaga() {
  yield takeLatest(reqChatStatus.type, fetchDataSaga);
}
